// Defaults
import { Content, ContainerBox, Calendly } from '@peakconcepts/landingpage-kit'
import defaultPages, { headerConfig } from './content/default/defaultPages'
import defaultSettings from './content/default/defaultSettings'
import seoHeaderData from './content/data/seoHeader'
import generalData from './content/default/data/general'

// Data
import heroData from './content/data/hero'
import infoData from './content/data/info'
import reviewsData from './content/data/reviews'
import info2Data from './content/data/info2'
import aboutData from './content/data/about'
import locationData from './content/data/location'
import processData from './content/data/process'
import contactData from './content/data/contact'
import faqsData from './content/data/faqs'

const content: Content = {
  ...defaultSettings,
  pages: [
    {
      path: '/',
      headerEnabled: true,
      seoHeaderConfig: seoHeaderData.main,
      sections: [
        {
          component: ContainerBox,
          data: {
            ...heroData
          }
        },
        {
          component: ContainerBox,
          data: {
            ...infoData
          }
        },
        {
          component: ContainerBox,
          data: {
            ...reviewsData
          }
        },
        {
          component: ContainerBox,
          data: {
            ...info2Data
          }
        },
        {
          component: ContainerBox,
          data: {
            ...aboutData
          }
        },
        {
          component: ContainerBox,
          data: {
            ...locationData
          }
        },
        {
          component: ContainerBox,
          data: {
            ...processData
          }
        },
        {
          component: ContainerBox,
          data: {
            ...contactData
          }
        },
        {
          component: ContainerBox,
          data: {
            ...faqsData
          }
        }
      ]
    },
    {
      path: '/termin-buchen',
      headerEnabled: true,
      headerConfig: {
        ...headerConfig,
        containerConfig: {
          className: 'is-hidden-mobile',
          padding: {
            fullHd: '20px 0',
            widescreen: '20px 0',
            desktop: '20px 0',
            tablet: '20px 0',
            mobile: '10px 0'
          },
          defaultCss: {
            backgroundColor: 'unset'
          }
        }
      },
      seoHeaderConfig: seoHeaderData.main,
      component: Calendly,
      data: {
        ...generalData.calendly
      }
    },
    ...defaultPages
  ]
}
export default content
